import { render, staticRenderFns } from "./CelestialQuoteHistory.vue?vue&type=template&id=018e25f2&"
import script from "./CelestialQuoteHistory.vue?vue&type=script&lang=js&"
export * from "./CelestialQuoteHistory.vue?vue&type=script&lang=js&"
import style0 from "./CelestialQuoteHistory.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports